<template>
  <v-row justify="space-around">
    <v-col cols="auto">
      <v-dialog v-model="showModal" max-width="400" persistent>
        <template>
          <v-card>
            <v-card-title> <v-row justify="center">Selecione o tipo de Impressão</v-row> </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" align="center" justify="center">
                  <v-card @click="emitGerarPdf" elevation="0" max-width="100" >
                    <v-icon color="blue lighten-1" large>mdi-file-document</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1">GERAR FOLHA</div>
                  </v-card>
                </v-col>

                <v-col cols="6" align="center" justify="center">
                  <v-card @click="emitGerarNota" elevation="0" max-width="100">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1">GERAR TICKET</div>
                  </v-card>
                </v-col>

                <v-col cols="6" align="center" justify="center">
                  <v-card @click="emitGerarComprovante" elevation="0" max-width="150">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1">GERAR COMPROVANTE</div>
                  </v-card>
                </v-col>

                <v-col cols="6" align="center" justify="center">
                  <v-card @click="emitGerarCupom" elevation="0" max-width="150">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1">GERAR CUPOM</div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn @click="emitCloseModal" color="grey darken-4" text>Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
  },

  methods: {
    emitGerarPdf() {
      this.$emit("event-gerar-pdf");
    },

    emitGerarNota() {
      this.$emit("event-gerar-nota");
    },

    emitGerarComprovante() {
      this.$emit("event-gerar-comprovante");
    },

    emitGerarCupom() {
      this.$emit("event-gerar-cupom");
    },

    emitCloseModal() {
      this.$emit("close-modal");
    },
  },
};
</script>
